<h1 class="container-heading">{{ state.action === "add" ? "Add" : "Edit" }} shipment</h1>

<mat-card>
    <mat-card-content>

        <mat-horizontal-stepper #stepper [linear]="true" (selectionChange)="handleStepChanges($event)">

            <ng-template matStepperIcon="edit">
                <mat-icon>done</mat-icon>
            </ng-template>

            <ng-template matStepperIcon="done">
                <mat-icon>done_all</mat-icon>
            </ng-template>

            <ng-template matStepperIcon="number" let-active="active" let-index="index">
                <mat-icon *ngIf="active; else elseIcon">create</mat-icon>
                <ng-template #elseIcon>{{ index + 1 }}</ng-template>
            </ng-template>

            <mat-step [editable]="step1.control.valid" [stepControl]="step1.control">

                <ng-template matStepLabel>Create shipment</ng-template>

                <div class="step">
                    <section-order-shipment-wizard-step1
                            (result)="step1.control.setValue($event)"></section-order-shipment-wizard-step1>
                    <div class="actions">
                        <button (click)="finish()"
                                mat-raised-button
                                color="primary"
                                type="button"
                                class="main">
                            Back to order
                        </button>
                    </div>
                </div>

            </mat-step>
        </mat-horizontal-stepper>

    </mat-card-content>
</mat-card>
